import { BadgeCheck } from "lucide-react";
import { format } from "date-fns";
import { useUserBadgesFor } from "@/hooks/useBadges";
import { badgeHex } from "@/lib/badgeColors";

/** Lists a member's earned active badges. Renders nothing when they have none. */
export function UserBadgesSection({ userId, title = "Badges" }: { userId: string | null | undefined; title?: string }) {
  const { badges } = useUserBadgesFor(userId);
  if (!userId || badges.length === 0) return null;

  return (
    <div className="space-y-2">
      <h3 className="text-sm font-semibold">{title}</h3>
      <ul className="space-y-2">
        {badges.map((b) => (
          <li key={b.badge_id} className="flex items-start gap-2 rounded-md border p-2">
            <BadgeCheck className="h-5 w-5 shrink-0 mt-0.5" style={{ color: badgeHex(b.color_key) }} />
            <div className="min-w-0">
              <p className="text-sm font-medium">{b.name}</p>
              {b.description && <p className="text-xs text-muted-foreground">{b.description}</p>}
              <p className="text-xs text-muted-foreground">Earned {format(new Date(b.awarded_at), "MMM d, yyyy")}</p>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
